<template>
  <section class="container-fluid col-md-10 offset-md-2 my-4">
    <h4 class="my-4">
      {{ isEdit ? 'Editando' : 'Cadastrando' }}
      <strong>Modelo de Documento</strong>
    </h4>

    <form @submit.prevent="handlerSubmit">
      <div class="row">
        <div class="form-group col-md-6 mb-3">
          <label for="name">Nome <span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            id="name"
            v-model="item.name"
            maxlength="100"
            required
          />
        </div>

        <div class="form-group col-md-6 mb-3">
          <label for="view_name">Arquivo (view) <span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            id="view_name"
            v-model="item.view_name"
            placeholder="ex: certificate-free-front"
            maxlength="100"
            required
          />
          <small class="text-muted">Nome do arquivo Blade em <code>resources/views/pdf/</code></small>
        </div>

        <div class="form-group col-md-12 mb-3">
          <label for="description">Descrição</label>
          <input
            type="text"
            class="form-control"
            id="description"
            v-model="item.description"
          />
        </div>

        <div class="form-group col-md-4 mb-3">
          <label for="type">Tipo <span class="text-danger">*</span></label>
          <select class="form-control" id="type" v-model="item.type" required>
            <option value="" disabled>-- Selecione --</option>
            <option value="certificate">certificate</option>
            <option value="history">history</option>
          </select>
        </div>

        <div class="form-group col-md-4 mb-3">
          <label for="paper_orientation">Orientação <span class="text-danger">*</span></label>
          <select class="form-control" id="paper_orientation" v-model="item.paper_orientation" required>
            <option value="landscape">landscape</option>
            <option value="portrait">portrait</option>
          </select>
        </div>

        <div class="form-group col-md-4 mb-3">
          <label for="paper_size">Tamanho <span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            id="paper_size"
            v-model="item.paper_size"
            placeholder="a4"
            maxlength="10"
            required
          />
        </div>

        <div class="form-group col-md-12 mb-3">
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              id="active"
              v-model="item.active"
            />
            <label class="form-check-label" for="active">Ativo</label>
          </div>
        </div>
      </div>

      <div class="form-group text-center my-2">
        <button type="submit" class="btn btn-success btn-sm mx-2" :disabled="loading">
          {{ loading ? 'Salvando...' : 'SALVAR' }}
        </button>
      </div>
    </form>

    <button class="btn btn-sm btn-secondary" @click="$router.go(-1)">VOLTAR</button>
  </section>
</template>

<script>
import api from "@/services";

export default {
  name: "DocumentTemplateForm",
  props: ["id"],
  data() {
    return {
      loading: false,
      item: {
        name: "",
        description: "",
        type: "certificate",
        view_name: "",
        paper_orientation: "landscape",
        paper_size: "a4",
        active: true,
      },
    };
  },
  computed: {
    isEdit() {
      return !!this.id;
    },
  },
  methods: {
    async getItem() {
      try {
        const { data } = await api.get(`/document-templates/${this.id}`);
        const d = data.data || data;
        this.item = {
          name: d.name || "",
          description: d.description || "",
          type: d.type || "certificate",
          view_name: d.view_name || "",
          paper_orientation: d.paper_orientation || "landscape",
          paper_size: d.paper_size || "a4",
          active: !!d.active,
        };
      } catch (error) {
        Toast.fire("Erro", error.response?.data?.message || "Erro ao carregar.", "error");
      }
    },
    async handlerSubmit() {
      this.loading = true;
      try {
        let res;
        if (this.isEdit) {
          res = await api.put(`/document-templates/${this.id}`, this.item);
        } else {
          res = await api.post("/document-templates", this.item);
        }
        Toast.fire(res.data.message || "Salvo com sucesso!", "", "success");
        this.$router.push({ name: "document-templates" });
      } catch (error) {
        const data = error.response?.data;
        let message = data?.message || "Erro ao salvar.";
        if (data?.errors) {
          message = Object.values(data.errors).flat().join("\n");
        }
        Toast.fire("Erro", message, "error");
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    if (this.isEdit) {
      this.getItem();
    }
  },
};
</script>
